import xs from "xstream"
import {div, label, input, button, p} from "@cycle/dom"
import * as R from "ramda"

import { CheckResult } from "../../../interface"

export const view = (user$, msg$, email$, mailCheck$) => {
	return xs.combine(user$, msg$, email$, mailCheck$)
		.map(([user, msg, { mailAddress }, mailCheck]:[any, string, any, string | null]) => {
			const curMail = R.path(["mailAddress"], user) || "未登録"
			return div(".form", [
          div(".row", [
            div(".px-2.mb-2", [
              div(".border.border-danger.border-2.p-2", [
                div(["1.新しく登録するメールアドレスを入力して「送信」ボタンを押してください。"]),
                div(".mt-1", ["2.確認メールが届きますので、メール内のリンクをクリックして登録を完了させてください。"]),
                // div(".mt-2.fw-bold", ["※携帯メールをご利用の場合は、info@jsrm.or.jpを受信できるように設定してください。"]),
              ]),
            ]),
          ]),
					div(".row.mt-2",[
						label(".form-label.mb-0",{attrs: {for:'email'}},["登録済メールアドレス"]),
						div(".col-sm-6.fw-bold",[curMail])
					]),
					div(".row.mt-2",[
						label(".form-label",{attrs: {for:'email'}},["新規メールアドレス"]),
						div(".col-sm-6",[
							input("#email.form-control", {attrs: {type:"email", placeholder:"メールアドレス", name:'email'}, props: {value: mailAddress}})
						])
					]),
					(msg !== null)
						? div(".col-sm-offset-3.caution.fw-bold.mt-1",["※",msg])
						: null
						,
					div(".d-grid.gap-2.d-md-flex.mt-4.justify-content-md-start",[
							button(`#btnQuery.btn.btn-primary.col-md-3.${mailCheck ? ".disabled" : ""}`, {
                attrs: {type: "button", disabled: mailCheck !== null }},["送信"]),
							button("#btnReturn.btn.btn-success.col-md-3", {attrs: {type: "button"}},["戻る"])
					]),
				])
		})
}
